// The model's own room-book pass, callable on its own or from inside build.
import { checkBuilding } from '../build';
import type { BuildStore, ToolFn, ToolSpec } from '../types';

export const checkSpec: ToolSpec = {
  name: 'check_building',
  description:
    'Check the building for what still needs fixing: a storey with no stair or ramp reaching it, a roof that no longer covers the tallest storey, a storey with walls but no floor slab, no doors or windows, or no rooms, and elements with no material. Returns findings, each with the storey it is about and, where there is an obvious fix, a suggested build action. Call this when the visitor asks what is wrong or missing, or after build to see what the change implies.',
  input_schema: { type: 'object', properties: {} },
};

export const check =
  (store?: BuildStore): ToolFn =>
  async () => {
    if (!store) return { error: 'no editable model is loaded' };
    const findings = await checkBuilding(store);
    return { findings };
  };
